import {fieldValidator, formDataFBuilder} from "../Core/common";
import Agent from "../Core/agent";
import {notice} from "../UI/notice";
import {modal} from "../UI/modal";
import FilterAPi from "../Api/filter-api";
import {changeInputFile} from "../input-file";
import Events from "../Core/Events";
import {calculator} from "../basket/Calculator/DefaultCalculator";

const state = {
    isPending: false,
};
let fileEvents = null;

const modalConfig = {
    'size': 'modal-dialog-centered',
    'title': '',
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">
                <div class="s-lg-24 fs-sm-20 fs-18 lh-0_9 mb-0 fw-bl">${modalConfig.title}</div>
                ${modalConfig.closeBtm}
                <hr>
            </div>`;
    },
    'closeBtm': `<button class="btn-close position-absolute end-0 top-0 border-0 ms-auto d-flex bg-transparent" data-bs-dismiss="modal"><i class="icon close"></i></button>`,
};

const sendInfo = async (output, button) => {
    button.classList.add('preloader');
    let response = await Agent.post('/api/v1/form/send-form', output);
    try {
        return await response.json();
    } catch (e) {
        notice(e.message);
    } finally {
        button.classList.remove('preloader');
    }
};

const initForm = async form => {
    let required_field_flag;

    form.querySelectorAll(`input, textarea`).forEach(el => {
        if (el.hasAttribute('name')) {
            el.addEventListener('input', event => {
                    let input = fieldValidator.bind(null, event.currentTarget);
                    clearTimeout(required_field_flag);
                    required_field_flag = setTimeout(input, 1000);
                }
            );

            el.addEventListener('focus', () => {
                el.classList.remove('is-invalid');
                el.classList.remove('is-valid');
            });

            el.addEventListener('blur', event => {
                let input = fieldValidator.bind(null, event.currentTarget);

                clearTimeout(required_field_flag);
                required_field_flag = setTimeout(input, 10);
            });

            if (el.getAttribute('type') === 'file') {
                el.addEventListener('change', () => changeInputFile(el));
            }
        }
    });
    let buttons = form.querySelectorAll('button[type="submit"]');
    if (!buttons.length) {
        buttons = form.querySelectorAll('button');
    }
    if (buttons) {
        let last = buttons[buttons.length - 1];
        let inputs = form.querySelectorAll(`input, textarea`);

        last.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            let isError = false;

            inputs.forEach(el => {
                if (el.hasAttribute('name')) {
                    if (!fieldValidator(el)) {
                        isError = true;
                    }
                }
            });

            if (!isError) {
                let userNameInput = form.querySelector('input[name="name"]');
                let phone = form.querySelector('input[name="phone"]').value;
                let userName = userNameInput ? userNameInput.value : '';

                let data = formDataFBuilder(form);
                data.append('key', 'msg_form');
                data.append('page', window.location.pathname.substr(1));
                data.append('product', last.dataset.product_id || 0);
                data.append('time_zone', document.querySelector('body').dataset.time_zone || 0);
                data.append('form_name', form.getAttribute("name"));
                data.append('ya_event_id', form.dataset.ya_id);
                data.append('ya_event_key', form.dataset.ya_key);
                let result = sendInfo(data, last);
                result.then(e => {
                    if (e.success) {
                        let filter = ['hidden', 'radio', 'checkbox', 'number', 'select', 'count', 'product', 'product_dependent'];

                        let js_form_file_list = form.querySelector('.js_form_file_list');
                        if (js_form_file_list) {
                            js_form_file_list.innerHTML = '';
                        }

                        inputs.forEach(el => {
                            if (!filter.includes(el.type)) {
                                el.value = '';
                            }

                            if (el.type === 'checkbox') {
                                el.checked = false;
                            }

                            el.classList.remove('is-invalid');
                            el.classList.remove('is-valid');
                        });
                        modalConfig.message = e.message;

                        modal(modalConfig, function (el, modal) {
                            setTimeout(modal.hide.bind(modal), 2000);
                        });
                        try {
                            state.events.dispatch('form_success_submitted');
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        notice(e.message);
                    }
                });
            }
        });
    }
};

const openForm = async btn => {
    let button = btn.currentTarget;
    button.disabled = true;
    if (!state.isPending) {
        state.isPending = true;

        let cnt = 1;
        let block = button.closest('.js_item');
        if (block) {
            let countElement = block.querySelector('[name="count"]');
            if (countElement) {
                cnt = countElement.value;
            }
        }

        let output = new FormData();
        output.append('key', 'open_form');
        output.append('ya_event_id', button.dataset.yaID);
        output.append('ya_event_key', button.dataset.yaKey);
        output.append('form_name', button.name || button.dataset.name);
        output.append('product', button.dataset.product_id || 0);
        output.append('employee', button.dataset.employee_id || 0);
        output.append('user', button.dataset.user);
        output.append('count', cnt);
        output.append('data_json', JSON.stringify({}));

        button.classList.add('preloader');

        let response = await Agent.post('/api/v1/form/open-form', output);
        try {
            const result = await response.json();
            if (result.success) {
                modalConfig.message = result.data || '';
                modalConfig.size = button.dataset.size || 'modal-dialog-centered';
                modalConfig.title = result.title || '';
                modal(modalConfig, function (el) {
                    let filterBtn = el.querySelector('.js_filter_select_btn');
                    if (filterBtn) {
                        let jsFilterResult = el.querySelector('.js_filter_result');
                        jsFilterResult.innerHTML = '';

                        filterBtn.addEventListener('click', () => {
                            let dataValuesString = [];
                            let dataValuesInt = [];
                            el.querySelectorAll('.js_filter_select').forEach(item => {
                                if (item.dataset.type === 'int') {
                                    dataValuesInt.push({
                                        id: item.dataset.parameter_id,
                                        name: item.dataset.alias,
                                        min: item.value,
                                        max: item.value
                                    });
                                }
                                if (item.dataset.type === 'string') {
                                    dataValuesString.push({
                                        id: item.dataset.parameter_id,
                                        name: item.dataset.alias,
                                        values: [item.value]
                                    });
                                }
                            });

                            let parameters = {
                                type: 'search_for_modal',
                                category: el.querySelector('.js_filter_category').value,
                                page: 1,
                                limit: 3,
                                float: dataValuesInt,
                                string: dataValuesString,
                            };

                            filterBtn.classList.add('preloader');

                            FilterAPi.search(parameters).then(response => response.json()).then(response => {
                                jsFilterResult.innerHTML = response.data;
                                fileEvents.dispatch('filter.search');
                            }).finally(() => {
                                filterBtn.classList.remove('preloader');
                            });
                        });
                    }
                    let form = el.querySelector('form');
                    if (form) {
                        initForm(form);
                    }
                    let calculatorEvent = new Events()
                    calculator(calculatorEvent).init(".modal-product__price");
                    calculatorEvent.addListener("paper.update", null, (element, data) => {
                        form.querySelectorAll('[name="count"]').forEach(countInput => {
                            countInput.value = data[0].count || 1;
                        });
                    })
                });
            } else {
                notice(result.message);
            }
        } catch (e) {
            notice(e.message);
        } finally {
            button.classList.remove('preloader');
            button.disabled = false;
            state.isPending = false;
        }
    }
};


export default class Forms {
    constructor(events) {
        fileEvents = events;
        this.events = events;
        state.events = events;

        this.initInlineForm(document);
        this.initModalForm(document);
    }

    initInlineForm(element) {
        element.querySelectorAll('.js_form').forEach(item => {
            initForm(item);
        });
    }

    initModalForm(element) {
        element.querySelectorAll('.js_open_form').forEach(item => {
            item.removeEventListener('click', openForm);
        });
        element.querySelectorAll('.js_open_form').forEach(item => {
            item.addEventListener('click', openForm);
        });
    }
}